export default __webpack_public_path__ + "static/media/SKN.efa5d9e3.svg";